import { render, staticRenderFns } from "./PartesEnvolvidasListagem.vue?vue&type=template&id=1019490f"
import script from "./PartesEnvolvidasListagem.vue?vue&type=script&lang=js"
export * from "./PartesEnvolvidasListagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports